import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class GenericModelAPI {

  static get = (module, id, success, failure) => {
    fetch(`${Config.app.link}api/${module}/${id}`, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (module, model, success, failure) => {
    fetch(`${Config.app.link}api/${module}/add-edit`, new Header('POST', model))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}

export default GenericModelAPI;